module.exports = __webpack_public_path__ + "img/icon-home.327487b2.svg";